import { getCurrentUser } from 'store/auth/selectors';
import { useSelector } from './use-selector';

export const useCurrentUser = () => {
    const currentUser = useSelector(getCurrentUser);
    return currentUser;
};
